import React, { Component } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

import { sortArrayByName } from '../../utils/array'
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'

class LeaflyMapCategoryItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const {
      data,
      mapping,
      categoryList = [],
      availableCategoryList = [],
      leaflyCategoryList,
      editMode,
    } = this.props

    const selectedCategory = categoryList.find((category) => category.id === data.categoryId) || {}

    const dbSelectedCategory =
      categoryList.find((category) => category.id === mapping.categoryId) || {}
    let categoryListValues = dbSelectedCategory.id
      ? [...availableCategoryList, dbSelectedCategory]
      : availableCategoryList
    categoryListValues = [...new Set(categoryListValues)]

    categoryListValues = sortArrayByName(categoryListValues.filter((category) => category.active))

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.categoryId}
            onChange={this.onChange('categoryId')}
            valueToRender={selectedCategory.name}
            editMode={editMode}
            MenuProps={{ className: 'no-backdrop-select' }}
          >
            {categoryListValues.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.leaflyCategory}
            onChange={this.onChange('leaflyCategory')}
            valueToRender={data.leaflyCategory}
            editMode={editMode}
            MenuProps={{ className: 'no-backdrop-select' }}
          >
            {leaflyCategoryList.map((item, index) => {
              return (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word">
          {hasAccess() ? (
            <div className="pull-right">
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
              {!editMode ? (
                <Button className="danger-button margin" onClick={this.props.onDelete}>
                  Delete
                </Button>
              ) : null}
            </div>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}

export default LeaflyMapCategoryItem



// WEBPACK FOOTER //
// ./src/components/Leafly/LeaflyMapCategoryItem.js